import axios from 'axios'

function request(opt) {
  let url
  if (process.env.NODE_ENV === "development") {
    url = this.$store.getters.serverUrl + opt.api;
  } else {
    url = this.$store.getters.serverUrl + opt.api;
  }

  if (opt.type && opt.type.toUpperCase() === 'POST') {
    axios.post(url, opt.param || {}).then(res => {
      if (res.status === 200) {
        opt.success && opt.success(res.data)
      } else {
        opt.error && opt.error(res.data)
      }
    }).catch(err => {
      opt.error && opt.error(err)
    })
    return;
  }
  
  axios.get(url, {params:opt.param} || {}).then(res => {
    if (res.status === 200) {
      opt.success && opt.success(res.data)
    } else {
      opt.error && opt.error(res.data)
    }
  }).catch(err => {
    opt.error && opt.error(err)
  })
}


export default request


// WEBPACK FOOTER //
// ./src/request/index.js